import { render, staticRenderFns } from "./Results.Superbet.vue?vue&type=template&id=08f1482e&"
import script from "./Results.Superbet.vue?vue&type=script&lang=js&"
export * from "./Results.Superbet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports